<template>
    <div class="menu-wrapper">
        <div class="overflow-container">
            <ul class="menu">
                <li v-for="item in menu" :key="item._id" :class="['menu-item', { active: subTypeId === item._id }]" @click="changeTab(item._id)">
                    <span>{{ item.name }}</span>
                    <el-dropdown v-if="!noEdit" trigger="click" @command="handleCommand">
                        <div class="more">
                            <i class="el-icon-more"></i>
                        </div>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="{ type: 'rename', data: item }">重命名</el-dropdown-item>
                            <el-dropdown-item :command="{ type: 'del', data: item }">删除</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </li>
                <li v-if="!noEdit" class="menu-item add" @click="open">
                    <i class="el-icon-plus">添加分类</i>
                </li>
            </ul>
        </div>

        <el-dialog v-if="dialogVisible" :title="dialogTitle" :visible.sync="dialogVisible" width="25%">
            <el-form :model="form" ref="ruleForm" label-width="120px" class="demo-ruleForm">
                <el-form-item label="分类名称" prop="name" verify>
                    <el-input v-model="form.name" size="small"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { saveSubcategories, delSubcategories } from "@/api/material";

export default {
    props: {
        typeId: String,
        subTypeId: String,
        menu: {
            type: Array,
            default: () => [],
        },
        noEdit: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dialogVisible: false,
            dialogTitle: "添加分类",
            form: {
                _id: "",
                name: "",
            },
        };
    },
    created() {},
    methods: {
        open(data) {
            this.dialogTitle = data?._id ? "编辑分类" : "添加分类";
            this.form = {
                _id: data._id,
                name: data.name,
            };
            this.dialogVisible = true;
        },

        async save() {
            let method = "POST";
            if (this.form._id) {
                method = "PUT";
            }
            const { status, message } = await saveSubcategories(method, {
                categoryId: this.typeId,
                subCategoryId: this.form._id,
                name: this.form.name,
            });
            if (status == 10000) {
                this.$message({
                    type: "success",
                    message,
                });
                this.$emit("getList");
                this.dialogVisible = false;
            } else {
                this.$message.error(message);
            }
        },
        del(data) {
            this.$confirm("此操作将永久删除该分类, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    const { status, message } = await delSubcategories({
                        categoryId: this.typeId,
                        subCategoryId: data._id,
                    });
                    if (status == 10000) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });
                        this.$emit("getList");
                    } else {
                        this.$message.error(message);
                    }
                })
                .catch(() => {
                    console.info("已取消删除!");
                });
        },
        handleCommand({ type: command, data }) {
            if (command === "rename") {
                this.open(data);
            } else if (command === "del") {
                this.del(data);
            }
        },

        changeTab(id) {
            this.$emit("getList", id);
        },
    },
};
</script>
<style lang="scss" scoped>
.menu-wrapper {
    .overflow-container {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.12);
        &::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 4px;
            background-color: rgba(0, 0, 0, 0.2);
        }
    }
}
.menu {
    width: 300px;
    height: 100%;
    // background-color: #f5f5f5;
}
.menu-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    height: 42px;
    font-size: 14px;
    cursor: pointer;
    &:hover {
        span {
            color: #2061e6;
        }
    }
    span {
        color: #333333;
    }
    .more {
        font-size: 12px;
        color: #666666;
        transform: rotate(0.25turn);
    }
    &.add {
        color: #2061e6;
    }
}
.menu-item.active {
    background-color: #f0f7ff;
    span {
        color: #2061e6;
    }
}
</style>
